import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { ApplicationDataService } from '../../../services/application.service';
import { CognitoCallback, LoggedInCallback } from '../../../services/cognito.service';
import { UserLoginService } from '../../../services/user-login.service';
import { UserRegistrationService } from '../../../services/user-registration.service';
import { UpdatePassword } from '../../models/updatepassword';
import { EventEmitterService } from 'services/event-emitter.service';
import { ErrorService } from 'services/error.service';

@Component({
  selector: 'app-newpassword',
  templateUrl: './newpassword.component.html',
  styleUrls: ['./newpassword.component.css']
})
export class NewpasswordComponent implements CognitoCallback, OnInit {
  model: UpdatePassword;
  hide: boolean = true;
  hide2: boolean = true;

  constructor(public userRegistrationService: UserRegistrationService, public userService: UserLoginService, public router: Router, private eventEmitterService: EventEmitterService,
    private applicationService: ApplicationDataService, private errorService: ErrorService) {
      this.model = new UpdatePassword();
      this.model.Email = this.userService.user;
      this.model.ExistingPassword = this.userService.pw;  
   }

  ngOnInit() {
    this.userService.isAuthenticated(this);
  }

  onSubmit() {
    this.applicationService.getCaseCorrectEmail(this.model.Email).subscribe(res => this.onEmailCheckResponse(res));
  }

  onEmailCheckResponse(caseCorrectEmail: string) {
    if(caseCorrectEmail) {
      this.model.Email = caseCorrectEmail;
    }
    
    this.userRegistrationService.newPassword(this.model, this);
  }

  cognitoCallback(message: string, result: any) {
        if (message != null) {
            this.errorService.showError(message);
        } else {
            localStorage.clear();
            this.eventEmitterService.renderConfirm(false);
            this.router.navigate(['/login']);
        }
    }

  isLoggedIn(message: string, isLoggedIn: boolean) {
    if (isLoggedIn) {
      this.router.navigate(['/application/landing']);
    }
  }

}
